import { useState } from "react";

import {
  BaseCurrencyInput,
  Button,
  Checkbox,
  Drawer,
  Hairline,
  Input,
} from "@components";

import { BoxTitles } from "@boxes/BoxTitles";

import styles from "@styles/forms-flow/forms.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const ConsumedProductsConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [collapsed, setCollapsed] = useState([]);
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "Nome do produto",
    },
    {
      id: 2,
      name: "Nome do produto 2",
    },
  ]);

  const Product = ({ product }) => {
    const collapseProduct = (product) => {
      let tempArr = collapsed;
      const index = tempArr.indexOf(product);

      if (index > -1) {
        tempArr = tempArr.filter((item) => item !== product);
      } else tempArr = [...tempArr, product];

      setCollapsed(tempArr);
    };

    return (
      <div className={styles.product}>
        <div
          className={styles.header}
          onClick={() => collapseProduct(product.id)}
        >
          <div className="d-flex align-center">
            <Checkbox />
            <p>{product.name}</p>
          </div>

          <i
            className={css({
              "fal fa-chevron-down": true,
              collapsed: collapsed.includes(product.id),
            })}
          />
        </div>

        {collapsed.includes(product.id) && (
          <div className={styles.content}>
            <div className="d-flex align-center">
              <BaseCurrencyInput
                suffix={" vezes"}
                prefix={""}
                precision={0}
                className="w-100"
                label="Qtd"
              />
              <BaseCurrencyInput
                suffix={" dias"}
                prefix={""}
                precision={0}
                className="ml-15 w-100"
                label="Nos últimos"
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.ConsumedProductsConditional}
    >
      <Input label="Buscar produto" />

      <Hairline className="mt-15 mb-30" />

      <p className={styles.label}>Produtos encontrados (x)</p>

      {products.map((product) => {
        return <Product product={product} />;
      })}

      <div className={styles.footer}>
        <Button onClick={() => onSave()} className="w-100" design="primary">
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
